import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4438fcee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "logo-block" }
const _hoisted_4 = { class: "menu-block" }
const _hoisted_5 = {
  class: "media",
  ref: "media"
}
const _hoisted_6 = { class: "viewer" }
const _hoisted_7 = {
  key: 1,
  class: "mobile-wrapper"
}
const _hoisted_8 = { class: "mobile-media" }
const _hoisted_9 = {
  key: 0,
  class: "mobile-home-about"
}
const _hoisted_10 = { class: "mobile-header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_about_view = _resolveComponent("about-view")!
  const _component_logo_block = _resolveComponent("logo-block")!
  const _component_menu_block = _resolveComponent("menu-block")!
  const _component_media_block = _resolveComponent("media-block")!
  const _component_viewer_block = _resolveComponent("viewer-block")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.loaded && !_ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([
      'main-wrapper', 
      {'about-active' : _ctx.$route.name ===  'about'},
      {'viewer-active' : _ctx.$route.name ===  'project'},
      {'transition-active' : _ctx.isTransition}
    ])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_about_view)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_logo_block)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_menu_block)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_media_block, {
              category: _ctx.curCategory,
              "delta-y": _ctx.deltaY
            }, null, 8, ["category", "delta-y"])
          ], 512),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_viewer_block)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.store.loaded && _ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_media_block, {
              category: _ctx.curCategory,
              deltaY: _ctx.deltaY
            }, null, 8, ["category", "deltaY"])
          ]),
          (_ctx.$route.name ===  'about')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_about_view)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_logo_block),
            _createVNode(_component_menu_block)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(['viewer', 'mobile-viewer', {'mobile-viewer-active': _ctx.$route.name ===  'project'}])
          }, [
            _createVNode(_component_viewer_block)
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}